import { Image as AntdImage } from 'antd'
import type { ImageProps as AntdImageProps } from 'antd'

import NoImageAvailableFallback from './assets/no-image-available.svg'

export interface ImageProps extends AntdImageProps {}

export const Image = (props: ImageProps) => {
  return <AntdImage fallback={NoImageAvailableFallback} {...props} />
}
